/** @prettier */

import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@mui/material';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useParams} from 'react-router-dom';

//MTH component import
import {PrimaryButton, SecondaryButton} from '../../component/BasicButton';
//API import
import {putSiteCalenderRoutine} from '../../API/API_Collection';
//interface import
import * as apiIF from '../../Type/api';

import {apiErrorAlert} from '../../functions/apiErrorAlert';

/**
 * カレンダー日付指定 削除ダイアログ
 * @param props props
 * - calenderRoutineData 標準設定のデータ
 * - isOpenDesignatedDayDeleteDialog 日付指定削除ダイアログ 表示フラグ
 * - setIsOpenDesignatedDayDeleteDialog 日付指定削除ダイアログ 表示フラグ 設定関数
 * - tableIndex 変更する設定の保存場所
 * - setIsRoutineChange 設定変更フラグ
 * @returns JSX
 */
export const DesignatedDayDeleteDialog = (props: {
  calenderRoutineData: apiIF.res.getSiteCalenderRoutine;
  isOpenDialog: boolean;
  setIsOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
  tableIndex: number;
  setIsRoutineChange: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const trans = useTranslation().t; //翻訳関数
  //パスパラメータ取得
  const {siteID} = useParams();

  /** API応答待ちフラグ */
  const [apiWait, setAPIWait] = useState(false);

  /**
   * 決定ボタンを押下時、日付設定を削除する
   */
  const handleOK = () => {
    if (siteID === undefined) {
      return;
    }

    setAPIWait(true);
    let tempData = props.calenderRoutineData;
    tempData['specified-day'].splice(props.tableIndex, 1);
    //編集API
    putSiteCalenderRoutine(siteID, tempData)
      .then(response => {
        //設定更新フラグをON
        props.setIsRoutineChange(true);
        //ダイアログを閉じる
        props.setIsOpenDialog(false);
      })
      .catch(err => {
        apiErrorAlert(trans);
      })
      .finally(() => {
        setAPIWait(false);
      });
  };

  /**
   * キャンセルボタンを押したときの処理 ダイアログを閉じる
   */
  const handleCancel = () => {
    props.setIsOpenDialog(false);
  };

  return (
    <Dialog
      open={props.isOpenDialog}
      onClose={() => props.setIsOpenDialog(false)}
      maxWidth="md">
      <DialogTitle>{trans('DesignatedDayDeleteDialog.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {trans('DesignatedDayDeleteDialog.explanation')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {/** CANCEL button */}
        <SecondaryButton
          onClick={handleCancel}
          disabled={apiWait}
          buttonText={trans('DesignatedDayDeleteDialog.buttonTxt.cancel')}
        />
        {/** OK button */}
        <PrimaryButton
          onClick={handleOK}
          disabled={apiWait}
          buttonText={trans('DesignatedDayDeleteDialog.buttonTxt.ok')}
        />
      </DialogActions>
    </Dialog>
  );
};
